"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  fillRule: "evenodd",
  d: "M15.158 7H8c-2.21 0-4 1.803-4 4.012v7.58a3.567 3.567 0 0 0 3.567 3.566h7.59a4 4 0 0 0 4-4v-7.146a4.01 4.01 0 0 0-4-4.012M8.5 7.5h5.58v9.083a.5.5 0 0 1-.812.39l-1.688-1.35-1.688 1.35c-.327.262-1.392.03-1.392-.39z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.5 4.4h-7.842a3.1 3.1 0 0 0-3.1 3.1h-1.4a4.5 4.5 0 0 1 4.5-4.5H18.5A4.5 4.5 0 0 1 23 7.5v7.842a4.5 4.5 0 0 1-4.5 4.5v-1.4a3.1 3.1 0 0 0 3.1-3.1V7.5a3.1 3.1 0 0 0-3.1-3.1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.342 7.558H7.5a3.1 3.1 0 0 0-3.1 3.1V18.5a3.1 3.1 0 0 0 3.1 3.1h7.842a3.1 3.1 0 0 0 3.1-3.1v-7.842a3.1 3.1 0 0 0-3.1-3.1m0-1.4H7.5a4.5 4.5 0 0 0-4.5 4.5V18.5A4.5 4.5 0 0 0 7.5 23h7.842a4.5 4.5 0 0 0 4.5-4.5v-7.842a4.5 4.5 0 0 0-4.5-4.5",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.945 7.056a.7.7 0 0 1 .7-.7H14.2a.7.7 0 0 1 .7.7v9.865c0 1.006-1.164 1.566-1.95.937l-1.528-1.222-1.528 1.222c-.786.629-1.95.07-1.95-.937zm1.4.7v8.75l1.64-1.313a.7.7 0 0 1 .875 0l1.64 1.312v-8.75z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CollectionMultiIcon26.js.map